import type { GoogleMapInstance } from '@/features/map/google-map/google-map-types';

import { atom, useAtomValue } from '@/core/features/store/atom-store';

export const googleMapInstanceAtom = atom<GoogleMapInstance | null>(null);
export const useGoogleMapInstance = () => useAtomValue(googleMapInstanceAtom);
